// extracted by mini-css-extract-plugin
export default {"container":"PipelineLegend_container__dHPHS","item":"PipelineLegend_item__4hgbg"};